import { render, staticRenderFns } from "./Retroceder.vue?vue&type=template&id=92fac27a"
import script from "./Retroceder.vue?vue&type=script&lang=js"
export * from "./Retroceder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports